import type { AutoSaveModel } from './autoSave';
import autoSaveModel from './autoSave';
import type { CorrectionFilterModel } from './correctionFilter';
import { correctionFilter } from './correctionFilter';
import type { DashboardFilterModel } from './dashboardFilter';
import { dashboardFilterModel } from './dashboardFilter';
import type { FeaturesModel } from './features';
import { featuresModel } from './features';
import type { LocaleModel } from './locale';
import { localeModel } from './locale';
import type { NotificationsModel } from './notifications';
import { notificationsModel } from './notifications';
import type { StudentModel } from './student';
import studentModel from './student';
import type { UserImpersonationModel } from './userImpersonation';
import { userImpersonationModel } from './userImpersonation';
import type { UserModeModel } from './userMode';
import { userModeModel } from './userMode';

export interface StoreModel {
    autoSave: AutoSaveModel;
    dashboardFilter: DashboardFilterModel;
    correctionFilter: CorrectionFilterModel;
    features: FeaturesModel;
    locale: LocaleModel;
    notifications: NotificationsModel;
    student: StudentModel;
    userImpersonation: UserImpersonationModel;
    userMode: UserModeModel;
}

const storeModel: StoreModel = {
    autoSave: autoSaveModel,
    dashboardFilter: dashboardFilterModel,
    correctionFilter: correctionFilter,
    features: featuresModel,
    locale: localeModel,
    notifications: notificationsModel,
    student: studentModel,
    userImpersonation: userImpersonationModel,
    userMode: userModeModel,
};

export default storeModel;
